import React from 'react';
import PropTypes from 'prop-types';
import Filter, { FilterModal, FilterSection } from './Filter';
import PrizeMoneyRangeFilter from './FilterComponents/PrizeMoneyRangeFilter';
import UtrFilterComponent from './FilterComponents/UtrFilterComponent';
import CheckboxFilterByType from './FilterComponents/CheckboxFilterByType';

import styles from '../search.scss';

const EventsMoreMobileFilter = (props) => {
    const { filterInputs, filters, handleFilterClick, filterModal, closeModals, handleFilterSubmit, clearFilters, eventsMoreMobileFiltersAreActive, searchTypes, userLoggedIn, hideFilters, state, handleFilterUpdate, mobileOnly, desktopOnly, 'data-testid': dataTestId } = props;
    return (
        <div className={styles.filterWrapper}>
            <Filter
                filterName={'eventsMoreMobile'}
                handleFilterClick={handleFilterClick}
                isActive={eventsMoreMobileFiltersAreActive || filterModal === 'eventsMoreMobile'}
                mobileOnly={mobileOnly}
                desktopOnly={desktopOnly}
                data-testid={dataTestId}
            >
                More...
            </Filter>
            {filterModal === 'eventsMoreMobile' && (
                <FilterModal
                    title={'More...'}
                    onCloseClick={closeModals}
                    clearFilters={() => clearFilters('eventsMore', true)}
                    scrollable={true}
                    handleFilterSubmit={handleFilterSubmit}
                    data-testid={dataTestId}
                >
                    <FilterSection data-testid={dataTestId && `${dataTestId}.body`}>
                        {(state.availableToursList?.length > 0 && !hideFilters.tours && userLoggedIn) && (
                            <div className={styles.searchFilterModalDiv} />
                        )}
                        <div className={styles.searchFilterModalTitle} data-testid={dataTestId && `${dataTestId}.event-type-title`}>Event Type</div>
                        <CheckboxFilterByType
                            searchTypes={searchTypes}
                            searchTypesPropName={`eventTypes`}
                            filterInputs={filterInputs}
                            filtersPropName={`eventTypes`}
                            onChange={(value) => {
                                handleFilterUpdate({
                                    eventTypes: {
                                        ...filterInputs.eventTypes,
                                        [value]: !filterInputs.eventTypes[value],
                                    },
                                });
                            }}
                            data-testid={dataTestId && `${dataTestId}.event-type-options`}
                        />

                        <div className={styles.searchFilterModalDiv} />
                        <div className={styles.searchFilterModalTitle} data-testid={dataTestId && `${dataTestId}.verified-event-title`}>Verified Event</div>
                        <CheckboxFilterByType
                            searchTypes={searchTypes}
                            searchTypesPropName={`utrType`}
                            filterInputs={filterInputs}
                            filtersPropName={`eventUtrTypes`}
                            onChange={(value) => {
                                handleFilterUpdate({
                                    eventUtrTypes: {
                                        ...filterInputs.eventUtrTypes,
                                        [value]: !filterInputs.eventUtrTypes[value],
                                    },
                                });
                            }}
                            data-testid={dataTestId && `${dataTestId}.utr-type-options`}
                        />

                        <div className={styles.searchFilterModalDiv} />
                        <PrizeMoneyRangeFilter
                            filterInputs={filterInputs}
                            searchTypes={searchTypes}
                            handlePrizeMoneyChange={(range) => {
                                handleFilterUpdate({
                                    prizeMoneyMin: range[0],
                                    prizeMoneyMax: range[1],
                                });
                            }}
                            data-testid={dataTestId && `${dataTestId}.prize-money-range`}
                        />

                        <div className={`${styles.searchFilterModalDiv} mt16`} />
                        <UtrFilterComponent
                            filterInputs={props.filterInputs}
                            filters={filters}
                            showExpandedUtrFilter={false}
                            handleUTRChange={(range) => {
                                handleFilterUpdate({
                                    utrMin: range[0],
                                    utrMax: range[1],
                                });
                            }}
                            handleUtrTypeClick={(utrType) => {
                                handleFilterUpdate({ utrType });
                            }}
                            handleUtrTeamTypeClick={(utrTeamType) => {
                                handleFilterUpdate({ utrTeamType });
                            }}
                            handleUtrReliabilityClick={(utrReliability) => {
                                handleFilterUpdate({ utrReliability });
                            }}
                            data-testid={dataTestId && `${dataTestId}.utr-filter`}
                        />

                        <div className={styles.searchFilterModalDiv} />
                        <div className={styles.searchFilterModalTitle} data-testid={dataTestId && `${dataTestId}.game-type-title`}>Game Type</div>
                        <CheckboxFilterByType
                            searchTypes={searchTypes}
                            searchTypesPropName={`eventTeamTypes`}
                            filterInputs={filterInputs}
                            filtersPropName={`eventTeamTypes`}
                            onChange={(value) => {
                                handleFilterUpdate({
                                    eventTeamTypes: {
                                        ...filterInputs.eventTeamTypes,
                                        [value]: !filterInputs.eventTeamTypes[value],
                                    },
                                });
                            }}
                            data-testid={dataTestId && `${dataTestId}.game-type-options`}
                        />

                        <div className={styles.searchFilterModalDiv} />
                        <div className={styles.searchFilterModalTitle} data-testid={dataTestId && `${dataTestId}.gender-title`}>Gender</div>
                        <CheckboxFilterByType
                            searchTypes={searchTypes}
                            searchTypesPropName={`eventGenders`}
                            filterInputs={filterInputs}
                            filtersPropName={`genders`}
                            onChange={(value) => {
                                handleFilterUpdate({
                                    genders: {
                                        ...filterInputs.genders,
                                        [value]: !filterInputs.genders[value],
                                    },
                                });
                            }}
                            data-testid={dataTestId && `${dataTestId}.gender-options`}
                        />
                    </FilterSection>
                </FilterModal>
            )}
        </div>
    );
};

EventsMoreMobileFilter.propTypes = {
    filterInputs: PropTypes.instanceOf(Object).isRequired,
    filters: PropTypes.instanceOf(Object).isRequired,
    handleFilterClick: PropTypes.func.isRequired,
    filterModal: PropTypes.string.isRequired,
    closeModals: PropTypes.func.isRequired,
    handleFilterSubmit: PropTypes.func.isRequired,
    clearFilters: PropTypes.func.isRequired,
    eventsMoreMobileFiltersAreActive: PropTypes.bool,
    searchTypes: PropTypes.instanceOf(Object).isRequired,
    userLoggedIn: PropTypes.bool,
    hideFilters: PropTypes.bool,
    state: PropTypes.instanceOf(Object).isRequired,
    handleFilterUpdate: PropTypes.func.isRequired,
    mobileOnly: PropTypes.bool.isRequired,
    desktopOnly: PropTypes.bool.isRequired,
    'data-testid': PropTypes.string,
};

EventsMoreMobileFilter.defaultProps = {
    eventsMoreMobileFiltersAreActive: false,
    userLoggedIn: false,
    hideFilters: false,
    'data-testid': undefined,
};

export default EventsMoreMobileFilter;
